/* =========================================================
   Koda & Co — Klaviyo WKGinY Confetti Version #6 (LUXE / Safari-safe)
   - NO external confetti lib required
   - ONE fixed canvas on <body>, clipped to popup rect
   - Teaser: once per popup open, ~25–30% drop
   - Success: full confetti once per page load
   - NO confetti on intermediate steps
   - SUCCESS LOCK (per Brian): ONLY "thank you for signing up"
   - NEW in v6: Safari success-button visibility repair (NO styling changes)
   - Exposes window.WKGINY_STATUS / WKGINY_TEST_TEASER / WKGINY_TEST_SUCCESS
========================================================= */
(function () {
  "use strict";

  /* =======================
     TOGGLES (safe to tweak)
  ======================= */
  const CFG = {
    DEBUG: false,

    // IMPORTANT: exact case-sensitive ID
    FORM_ID: "WKGinY",

    // Presets: "LUXE" (default) or "CELEBRATE"
    PRESET: "LUXE",

    // Brand colors (+ white sparkle always mixed in)
    COLORS: ["#0059FD", "#d4d8e6", "#242839", "#858BA1", "#a9aec5"],
    WHITE_SPARKLE: "#FFFFFF",
    WHITE_RATIO: 0.18, // keep as-is (v4 baseline)

    // Teaser (popup open)
    TEASER_ENABLED: true,
    TEASER_DURATION_MS: 1200,
    TEASER_EMIT_PER_SEC: 120,
    TEASER_MAX_FALL_FRAC: 0.30,
    TEASER_FADE_START: 0.55,

    // Success (success step)
    SUCCESS_ENABLED: true,
    SUCCESS_DURATION_MS: 2850,
    SUCCESS_EMIT_PER_SEC: 280,
    SUCCESS_MAX_FALL_FRAC: 1.0,
    SUCCESS_FADE_START: 0.70,

    // Behavior
    EMIT_FROM_ABOVE_MASCOTS_PX: 140,
    STOP_HARD_MS: 3000,
    CLIP_PAD_PX: 10,
    Z_INDEX: 2147483647,

    // v6 ONLY: Safari success-button fix
    SAFARI_BUTTON_FIX_ENABLED: true
  };

  function log() {
    if (CFG.DEBUG) console.log("[WKGinY Confetti]", ...arguments);
  }

  // Preset tuning (unchanged)
  const PRESETS = {
    LUXE: {
      gravity: 520,
      drift: 0.985,
      sizeMin: 4,
      sizeMax: 9,
      sparkleMin: 2,
      sparkleMax: 4,
      velX: 70,
      velY0Min: 18,
      velY0Max: 55,
      rotVel: 5.5,
      alphaDecay: 0.028
    },
    CELEBRATE: {
      gravity: 760,
      drift: 0.982,
      sizeMin: 6,
      sizeMax: 13,
      sparkleMin: 2,
      sparkleMax: 5,
      velX: 95,
      velY0Min: 20,
      velY0Max: 70,
      rotVel: 7.5,
      alphaDecay: 0.034
    }
  };

  const P = PRESETS[CFG.PRESET] || PRESETS.LUXE;

  function rand(min, max) { return Math.random() * (max - min) + min; }

  function isVisible(el) {
    if (!el) return false;
    const cs = window.getComputedStyle(el);
    if (cs.display === "none" || cs.visibility === "hidden" || Number(cs.opacity) === 0) return false;
    const r = el.getBoundingClientRect();
    return r.width > 40 && r.height > 40;
  }

  function popupText(el) {
    return (el && el.innerText ? el.innerText : "").toLowerCase();
  }

  // Find any node inside the Klaviyo form popup referencing the form id
  function findFormMarkerNode() {
    const id = CFG.FORM_ID;
    const selectors = [
      `[data-testid*="${id}"]`,
      `[data-form-id*="${id}"]`,
      `[data-formid*="${id}"]`,
      `[id*="${id}"]`,
      `[class*="${id}"]`,
      `[data-variant*="${id}"]`
    ].join(",");

    const nodes = Array.prototype.slice.call(document.querySelectorAll(selectors));
    for (const n of nodes) if (isVisible(n)) return n;
    return nodes[0] || null;
  }

  // Walk up to the popup "panel" (not the full-screen overlay)
  function findPopupBoxFrom(node) {
    if (!node) return null;

    let el = node;
    for (let i = 0; i < 24 && el; i++) {
      if (isVisible(el)) {
        const r = el.getBoundingClientRect();
        const ok =
          r.width > 360 && r.height > 260 &&
          r.width < window.innerWidth * 0.98 &&
          r.height < window.innerHeight * 0.98;

        if (ok) {
          const cs = window.getComputedStyle(el);
          const bg = cs.backgroundColor;
          const hasBg = bg && bg !== "transparent" && bg !== "rgba(0, 0, 0, 0)";
          if (hasBg) return el;
          if (r.width < window.innerWidth * 0.92) return el;
        }
      }
      el = el.parentElement;
    }

    el = node;
    while (el && !isVisible(el)) el = el.parentElement;
    return el || null;
  }

  /* =========================
     SUCCESS detection (LOCK)
     - ONLY "thank you for signing up"
     - handles ALL CAPS because we lower-case popupText()
  ========================= */
  function successVisible(popupBox) {
    const t = popupText(popupBox);
    return t.includes("thank you for signing up");
  }

  /* =========================
     v6: Safari success button repair
     - Only runs ON SUCCESS step
     - Only touches visibility/opacity/pointer-events/display
     - Does NOT change colors/spacing/fonts/etc.
  ========================= */
  function repairSuccessButtons(popupBox) {
    if (!CFG.SAFARI_BUTTON_FIX_ENABLED || !popupBox) return;

    // Only when success screen is truly visible
    if (!successVisible(popupBox)) return;

    const nodes = popupBox.querySelectorAll("a,button,[role='button']");
    if (!nodes || !nodes.length) return;

    for (const el of nodes) {
      const tag = (el.tagName || "").toLowerCase();
      const text = ((el.innerText || el.textContent || "")).trim().toLowerCase();
      const href = (el.getAttribute && el.getAttribute("href")) ? el.getAttribute("href") : "";

      // Target only the success CTAs you care about (and avoid random hidden stuff)
      const isRewards =
        href.includes("/pages/rewards") ||
        href.includes("kodaco.shop/pages/rewards") ||
        text.includes("unlock vip") ||
        text.includes("rewards");

      const isShopAll =
        href.includes("/collections/all") ||
        text.includes("keep shopping") ||
        text.includes("start shopping");

      if (!isRewards && !isShopAll) continue;

      // Force visibility without altering design choices
      el.style.visibility = "visible";
      el.style.opacity = "1";
      el.style.pointerEvents = "auto";

      // Some Safari cases hide via display:none/inline-block mismatches
      const cs = window.getComputedStyle(el);
      if (cs.display === "none") {
        el.style.display = (tag === "a") ? "inline-block" : "inline-flex";
      }

      // If a parent wrapper is hiding it, unhide up the chain (limited depth)
      let p = el.parentElement;
      for (let i = 0; i < 6 && p; i++) {
        const pcs = window.getComputedStyle(p);
        if (pcs.visibility === "hidden") p.style.visibility = "visible";
        if (Number(pcs.opacity) === 0) p.style.opacity = "1";
        if (pcs.display === "none") p.style.display = "block";
        p = p.parentElement;
      }
    }
  }

  /* ========= Canvas overlay ========= */
  function ensureCanvas() {
    let canvas = document.getElementById("wk-giny-confetti-canvas");
    if (canvas) return canvas;

    canvas = document.createElement("canvas");
    canvas.id = "wk-giny-confetti-canvas";
    canvas.style.position = "fixed";
    canvas.style.inset = "0";
    canvas.style.width = "100vw";
    canvas.style.height = "100vh";
    canvas.style.pointerEvents = "none";
    canvas.style.zIndex = String(CFG.Z_INDEX);
    document.body.appendChild(canvas);
    return canvas;
  }

  function resizeCanvas(canvas) {
    const dpr = Math.max(1, window.devicePixelRatio || 1);
    canvas.width = Math.floor(window.innerWidth * dpr);
    canvas.height = Math.floor(window.innerHeight * dpr);
    const ctx = canvas.getContext("2d");
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    return ctx;
  }

  function pickColor() {
    if (Math.random() < CFG.WHITE_RATIO) return CFG.WHITE_SPARKLE;
    return CFG.COLORS[(Math.random() * CFG.COLORS.length) | 0];
  }

  function runConfettiInRect(rect, mode) {
    const isTeaser = mode === "teaser";

    const dur = isTeaser ? CFG.TEASER_DURATION_MS : CFG.SUCCESS_DURATION_MS;
    const emitPerSec = isTeaser ? CFG.TEASER_EMIT_PER_SEC : CFG.SUCCESS_EMIT_PER_SEC;
    const fadeStart = isTeaser ? CFG.TEASER_FADE_START : CFG.SUCCESS_FADE_START;
    const maxFall = isTeaser ? CFG.TEASER_MAX_FALL_FRAC : CFG.SUCCESS_MAX_FALL_FRAC;

    const canvas = ensureCanvas();
    let ctx = resizeCanvas(canvas);

    const pad = CFG.CLIP_PAD_PX;
    const clipX = rect.left - pad;
    const clipY = rect.top - pad;
    const clipW = rect.width + pad * 2;
    const clipH = rect.height + pad * 2;

    const emitY = rect.top - CFG.EMIT_FROM_ABOVE_MASCOTS_PX;

    const particles = [];
    const start = performance.now();
    let carry = 0;
    let lastT = start;

    function spawn(n) {
      for (let i = 0; i < n; i++) {
        const isSparkle = Math.random() < CFG.WHITE_RATIO * 0.9;

        const shapeRoll = Math.random();
        const shape =
          isSparkle ? "sparkle" :
          shapeRoll < 0.72 ? "rect" :
          shapeRoll < 0.93 ? "slim" : "chip";

        const s = isSparkle ? rand(P.sparkleMin, P.sparkleMax) : rand(P.sizeMin, P.sizeMax);
        const h = shape === "slim" ? rand(s * 1.8, s * 3.0) : rand(s * 0.9, s * 1.8);

        particles.push({
          x: rect.left + rand(0, rect.width),
          y: emitY + rand(-18, 10),
          vx: rand(-P.velX, P.velX),
          vy: rand(P.velY0Min, P.velY0Max),
          rot: rand(0, Math.PI * 2),
          vr: rand(-P.rotVel, P.rotVel),
          s,
          h,
          c: pickColor(),
          shape,
          a: 1
        });
      }
    }

    function drawParticle(p) {
      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rot);
      ctx.globalAlpha = Math.max(0, Math.min(1, p.a));
      ctx.fillStyle = p.c;

      if (p.shape === "sparkle") {
        ctx.beginPath();
        ctx.arc(0, 0, p.s * 0.5, 0, Math.PI * 2);
        ctx.fill();
      } else if (p.shape === "slim") {
        ctx.fillRect(-2, -p.h / 2, 4, p.h);
      } else if (p.shape === "chip") {
        ctx.rotate(Math.PI / 6);
        ctx.fillRect(-p.s / 2, -p.s / 2, p.s, p.s);
      } else {
        ctx.fillRect(-p.s / 2, -p.h / 2, p.s, p.h);
      }

      ctx.restore();
    }

    function tick(now) {
      ctx = resizeCanvas(canvas);

      const dt = Math.min(0.05, (now - lastT) / 1000);
      lastT = now;

      ctx.save();
      ctx.beginPath();
      ctx.rect(clipX, clipY, clipW, clipH);
      ctx.clip();

      ctx.clearRect(clipX, clipY, clipW, clipH);

      const elapsed = now - start;

      if (elapsed < dur) {
        carry += emitPerSec * dt;
        const emitNow = Math.floor(carry);
        carry -= emitNow;
        if (emitNow) spawn(emitNow);
      }

      const t = dur ? (elapsed / dur) : 1;
      const killY = rect.top + rect.height * maxFall + 60;

      for (let i = particles.length - 1; i >= 0; i--) {
        const p = particles[i];

        p.vy += P.gravity * dt;
        p.x += p.vx * dt;
        p.y += p.vy * dt;
        p.rot += p.vr * dt;

        p.vx *= P.drift;

        if (t > fadeStart) p.a -= P.alphaDecay;

        drawParticle(p);

        if (p.y > killY || p.a <= 0) particles.splice(i, 1);
      }

      ctx.restore();

      if (elapsed < Math.min(dur, CFG.STOP_HARD_MS) || particles.length) {
        requestAnimationFrame(tick);
      }
    }

    requestAnimationFrame(tick);
  }

  /* ========= State gating ========= */
  let lastOpenKey = null;
  let teaserFiredKey = null;
  let successFiredThisLoad = false;

  function computeOpenKey(rect) {
    return `${Math.round(rect.left)}:${Math.round(rect.top)}:${Math.round(rect.width)}:${Math.round(rect.height)}`;
  }

  function getState() {
    const marker = findFormMarkerNode();
    const box = findPopupBoxFrom(marker);

    if (!box || !isVisible(box)) {
      return { found: false, panelVisible: false, box: null, rect: null };
    }

    const rect = box.getBoundingClientRect();
    return { found: true, panelVisible: true, box, rect };
  }

  function loop() {
    try {
      const st = getState();

      if (!st.panelVisible) {
        lastOpenKey = null;
        teaserFiredKey = null;
        requestAnimationFrame(loop);
        return;
      }

      const key = computeOpenKey(st.rect);

      // Popup open edge
      if (key !== lastOpenKey) {
        lastOpenKey = key;

        // Teaser once per open (but never on success view)
        if (CFG.TEASER_ENABLED && teaserFiredKey !== key && !successVisible(st.box)) {
          teaserFiredKey = key;
          log("Teaser fired");
          runConfettiInRect(st.rect, "teaser");
        }
      }

      // Success: once per PAGE LOAD
      if (CFG.SUCCESS_ENABLED && !successFiredThisLoad && successVisible(st.box)) {
        successFiredThisLoad = true;
        log("Success fired");
        runConfettiInRect(st.rect, "success");
      }

      // v6: Repair Safari success buttons (only on success)
      repairSuccessButtons(st.box);

    } catch (e) {
      if (CFG.DEBUG) console.warn("[WKGinY Confetti] loop error", e);
    }

    requestAnimationFrame(loop);
  }

  /* ========= Public helpers ========= */
  window.WKGINY_STATUS = function () {
    const st = getState();
    return {
      found: st.found,
      panelVisible: st.panelVisible,
      testid: `klaviyo-form-${CFG.FORM_ID}`,
      preset: CFG.PRESET,
      successFiredThisLoad
    };
  };

  window.WKGINY_TEST_TEASER = function () {
    const st = getState();
    if (!st.panelVisible) return { ok: false, reason: "no visible popup panel" };
    runConfettiInRect(st.rect, "teaser");
    return { ok: true, mode: "teaser" };
  };

  window.WKGINY_TEST_SUCCESS = function () {
    const st = getState();
    if (!st.panelVisible) return { ok: false, reason: "no visible popup panel" };
    runConfettiInRect(st.rect, "success");
    return { ok: true, mode: "success" };
  };

  loop();
})();